import React from 'react';
import { Route } from 'react-router-dom';
import { PrivateRoute, PermissionRoute } from '@/routes/guards';
import { lazyWithRetry } from '@/routes/utils';

const MyProjects = lazyWithRetry(() => import('@/pages/projects/MyProjects'));
const PublicProjects = lazyWithRetry(() => import('@/pages/projects/PublicProjects'));
const CreateProject = lazyWithRetry(() => import('@/pages/projects/CreateProject'));
const EditProject = lazyWithRetry(() => import('@/pages/projects/EditProject'));
const ProjectView = lazyWithRetry(() => import('@/pages/projects/ProjectView'));

export const projectsRoutes = (
  <>
    <Route
      path="/projects/my"
      element={
        <PrivateRoute>
          <MyProjects />
        </PrivateRoute>
      }
    />
    <Route path="/projects/public" element={<PublicProjects />} />
    <Route
      path="/projects/create"
      element={
        <PermissionRoute permission="can_create_projects">
          <CreateProject />
        </PermissionRoute>
      }
    />
    <Route
      path="/projects/edit/:projectName"
      element={
        <PermissionRoute permission="can_publish_project">
          <EditProject />
        </PermissionRoute>
      }
    />
    <Route path="/projects/:projectName" element={<ProjectView />} />
  </>
);
